import { render } from "./Circle.vue?vue&type=template&id=1dc5e69e"
import script from "./Circle.vue?vue&type=script&lang=js"
export * from "./Circle.vue?vue&type=script&lang=js"
script.render = render

export default script